<template>
  <main class="ws">

<!-- ============ 1 首屏 ============ -->
<section class="lhero lhero--c lhero--dark">
  <div class="wrap">
    <span class="hero-pill"><span class="zh">{{ $t("给海外卖家") }}</span><span class="en">For sellers outside China</span></span>
    <h1 class="lhero__title">
      <span class="zh">{{ $t("在中国的货架上选品") }}<br>{{ $t("在你自己的店里卖") }}</span>
      <span class="en">Pick from China's shelves.<br>Sell from your own store.</span>
    </h1>
    <p class="lhero__sub">
      <span class="zh">{{ $t("不用飞中国、不用懂中文、不用先压一批货。") }}<br>{{ $t("你选好商品，") }}<b>{{ $t("采购、检查、打包、发货我们来做") }}</b>{{ $t("。") }}</span>
      <span class="en">No flight to China. No Mandarin. No inventory upfront.<br>You choose the products — <b>we buy, inspect, pack and ship</b>.</span>
    </p>
    <div class="btns">
      <router-link class="btn btn--primary" to="/sign-up"><span class="zh">{{ $t("免费开店，先挑 3 件商品试试") }}</span><span class="en">Start free — list 3 products</span></router-link>
      <router-link class="btn btn--ghost" to="/template-index"><span class="zh">{{ $t("先看看店长什么样") }}</span><span class="en">See what a store looks like</span></router-link>
    </div>
    <p class="lhero__note"><span class="zh">{{ $t("一件代发 · 不压库存 · 佣金低至 3%") }}</span><span class="en">Dropship · No stock · commission from 3%</span></p>
  </div>

  <div class="wrap hero__mock">
    <div class="mock">
      <div class="mock__bar">
        <span class="mock__dots"><i></i><i></i><i></i></span>
        <span class="mock__url"><i></i>yourstore.com/admin/orders</span>
      </div>
      <div class="mock__body">
        <div class="mock__side">
          <div class="mock__brand"><b></b><span>My Store</span></div>
          <div class="mock__nav-item on"><svg class="ico"><use href="#i-box"/></svg><em><span class="zh">{{ $t("订单") }}</span><span class="en">Orders</span></em></div>
          <div class="mock__nav-item"><svg class="ico"><use href="#i-grid"/></svg><em><span class="zh">{{ $t("商品") }}</span><span class="en">Catalog</span></em></div>
          <div class="mock__nav-item"><svg class="ico"><use href="#i-truck"/></svg><em><span class="zh">{{ $t("物流") }}</span><span class="en">Shipping</span></em></div>
          <div class="mock__nav-item"><svg class="ico"><use href="#i-card"/></svg><em><span class="zh">{{ $t("收款") }}</span><span class="en">Payouts</span></em></div>
          <div class="mock__nav-item"><svg class="ico"><use href="#i-gear"/></svg><em><span class="zh">{{ $t("设置") }}</span><span class="en">Settings</span></em></div>
        </div>
        <div class="mock__main">
          <div class="mock__head">
            <span class="mock__title"><span class="zh">{{ $t("订单") }}</span><span class="en">Orders</span></span>
            <span class="mock__langs">
              <i class="on">EN</i><i>FR</i><i>DE</i><i>ES</i>
            </span>
          </div>
          <div class="mock__kpis">
            <div class="mock__kpi"><span class="zh">{{ $t("待处理") }}</span><span class="en">Open</span><strong>4</strong></div>
            <div class="mock__kpi"><span class="zh">{{ $t("运输中") }}</span><span class="en">In transit</span><strong>12</strong></div>
            <div class="mock__kpi"><span class="zh">{{ $t("已签收") }}</span><span class="en">Delivered</span><strong>6</strong></div>
          </div>
          <div class="mock__rows">
            <div class="mock__row">
              <span class="mock__ri"><svg><use href="#i-tee"/></svg></span>
              <span class="mock__rno">#TF-2841<small>Yanwen · 6–9 days</small></span>
              <b>In transit</b>
            </div>
            <div class="mock__row">
              <span class="mock__ri"><svg><use href="#i-bag"/></svg></span>
              <span class="mock__rno">#TF-2839<small>Inspected · packed</small></span>
              <b>Inspected</b>
            </div>
            <div class="mock__row">
              <span class="mock__ri"><svg><use href="#i-box"/></svg></span>
              <span class="mock__rno">#TF-2836<small>4PX · signed for</small></span>
              <b>Delivered</b>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mock__float">
      <span class="ico-badge ico-badge--sm" style="width:26px;height:26px;border-radius:8px"><svg class="ico" style="width:14px;height:14px"><use href="#i-pin"/></svg></span>
      <div>
        <div style="font-size:12px;color:#1A1626;font-weight:500"><span class="zh">{{ $t("物流全程可查") }}</span><span class="en">Tracked end to end</span></div>
        <div style="font-size:10.5px;color:#9A9AA8"><span class="zh">{{ $t("燕文 · 4PX · 集运合箱") }}</span><span class="en">Yanwen · 4PX · Consolidated</span></div>
      </div>
    </div>
  </div>
</section>

<!-- ============ 2 六件事 ============ -->
<!-- 吉祥物引导带 -->
<div class="guide-band">
  <div class="wrap">
    <img class="guide__m" src="/website/img/tao-box.png" alt="">
    <div class="bubble">{{ $t("中国的货架上有什么、怎么运到你手上，") }}<b>{{ $t("往下翻都能看到") }}</b>{{ $t("。先看你在第一步卡在哪。") }}</div>
  </div>
</div>

<section class="sec" id="pains">
  <div class="wrap">
    <div class="sec__head">
      <span class="pill"><span class="zh">{{ $t("从选品到客户收到货") }}</span><span class="en">From picking to delivery</span></span>
      <h2 class="sec__title"><span class="zh">{{ $t("这几步，我们替你做了") }}</span><span class="en">We do these steps for you</span></h2>
    </div>

    <div class="pains">
      <article class="pain">
        <div class="pain__top">
          <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-search"/></svg></span>
          <span class="pain__no">01</span>
        </div>
        <h3 class="pain__q"><span class="zh">{{ $t("想卖中国货，不知道找谁拿货？") }}</span><span class="en">Where do I source Chinese products?</span></h3>
        <p class="pain__do">
          <span class="zh">{{ $t("打开商品库，按品类、价格、销量筛。每件商品都有实拍图和规格，看中的直接加进你的店。") }}</span>
          <span class="en">Open the catalog and filter by category, price and sales volume. Every listing has real photos and specs — add it to your store in one click.</span>
        </p>
        <p class="pain__res"><span class="zh">{{ $t("不用自己跑工厂、不用加中间商") }}</span><span class="en">No factory trips. No middlemen.</span></p>
      </article>

      <article class="pain">
        <div class="pain__top">
          <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-chat"/></svg></span>
          <span class="pain__no">02</span>
        </div>
        <h3 class="pain__q"><span class="zh">{{ $t("不会中文，怎么跟供应商谈？") }}</span><span class="en">No Mandarin. How do I deal with suppliers?</span></h3>
        <p class="pain__do">
          <span class="zh">{{ $t("不用谈。下单、检查、安排发货都由平台完成，你只跟平台说你的语言。") }}</span>
          <span class="en">You don't. Ordering, inspection and shipping are handled by the platform. You only talk to us — in your language.</span>
        </p>
        <p class="pain__res"><span class="zh">{{ $t("全程不需要一句中文") }}</span><span class="en">Not a word of Mandarin required.</span></p>
      </article>

      <article class="pain">
        <div class="pain__top">
          <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-box"/></svg></span>
          <span class="pain__no">03</span>
        </div>
        <h3 class="pain__q"><span class="zh">{{ $t("怕压一批货卖不掉？") }}</span><span class="en">I can't risk stock that won't sell.</span></h3>
        <p class="pain__do">
          <span class="zh">{{ $t("一件代发。客户在你的店下单，我们才去采购和发货，你手上不压库存，也不占资金。") }}</span>
          <span class="en">Dropship. We only buy and ship after your customer orders, so nothing sits in your storage and no cash is tied up.</span>
        </p>
        <p class="pain__res"><span class="zh">{{ $t("零库存起步，卖不动不亏钱") }}</span><span class="en">Start at zero inventory.</span></p>
      </article>

      <article class="pain">
        <div class="pain__top">
          <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-shield"/></svg></span>
          <span class="pain__no">04</span>
        </div>
        <h3 class="pain__q"><span class="zh">{{ $t("怕收到的货跟图片不一样？") }}</span><span class="en">What if the goods don't match the photos?</span></h3>
        <p class="pain__do">
          <span class="zh">{{ $t("商品由平台审核后进入商品库，出库前检查。坏损、错发按平台规则处理，不用你自己去跟工厂扯。") }}</span>
          <span class="en">Products are reviewed before they enter the catalog, and checked again before dispatch. Damaged or wrong items are handled under platform rules.</span>
        </p>
        <p class="pain__res"><span class="zh">{{ $t("出了问题有人负责") }}</span><span class="en">Someone else deals with the factory.</span></p>
      </article>

      <article class="pain">
        <div class="pain__top">
          <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-pin"/></svg></span>
          <span class="pain__no">05</span>
        </div>
        <h3 class="pain__q"><span class="zh">{{ $t("客户等不及，一直催单？") }}</span><span class="en">Customers keep chasing their parcels.</span></h3>
        <p class="pain__do">
          <span class="zh">{{ $t("国际专线直发，全程可查。客户在你的店里就能看到货走到哪了，不用来问你。") }}</span>
          <span class="en">Direct international lines, fully trackable. Your customer sees the status in your store — without asking you.</span>
        </p>
        <p class="pain__res"><span class="zh">{{ $t("物流进度客户自己看") }}</span><span class="en">Tracking answers for you.</span></p>
      </article>

      <article class="pain">
        <div class="pain__top">
          <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-percent"/></svg></span>
          <span class="pain__no">06</span>
        </div>
        <h3 class="pain__q"><span class="zh">{{ $t("收款要等多久，平台抽多少？") }}</span><span class="en">When do I get paid? Any commission?</span></h3>
        <p class="pain__do">
          <span class="zh">{{ $t("客户用他们习惯的方式付款。平台不从你的销售里抽成，卖多少你收多少。") }}</span>
          <span class="en">Customers pay the way they're used to. We take no cut from your sales — you keep what you charge.</span>
        </p>
        <p class="pain__res"><span class="zh">{{ $t("佣金按阶梯，最高也只 6%") }}</span><span class="en">Tiered commission, capped at 6%.</span></p>
      </article>
    </div>
  </div>
</section>

<!-- ============ 3 第一公里 ============ -->
<section class="sec sec--gray" id="firstmile">
  <div class="wrap">
    <div class="sec__head">
      <span class="pill"><span class="zh">{{ $t("这一段叫「第一公里」") }}</span><span class="en">This part is the first mile</span></span>
      <h2 class="sec__title">
        <span class="zh">{{ $t("把货送出中国，是别人的问题") }}<br>{{ $t("把货从工厂弄到你手上，才是你的问题") }}</span>
        <span class="en">Shipping out of China is solved.<br>Getting goods into your hands is not.</span>
      </h2>
      <p class="sec__sub">
        <span class="zh">{{ $t("紫色是我们替你办的，灰色是你只需要做的那一步。") }}</span>
        <span class="en">Purple is what we handle. Grey is all you have to do.</span>
      </p>
    </div>

    <div class="flow">
      <div class="flow__node flow__node--us">
        <div class="flow__icon"><svg class="ico"><use href="#i-factory"/></svg></div>
        <em><span class="zh">{{ $t("中国工厂") }}</span><span class="en">Chinese factory</span></em>
        <p><span class="zh">{{ $t("按你的选品采购") }}<br>{{ $t("先验资质再下单") }}</span><span class="en">Sourced to your selection<br>Suppliers vetted first</span></p>
      </div>
      <div class="flow__arrow">→</div>
      <div class="flow__node flow__node--us">
        <div class="flow__icon"><svg class="ico"><use href="#i-warehouse"/></svg></div>
        <em><span class="zh">{{ $t("平台仓") }}</span><span class="en">Our warehouse</span></em>
        <p><span class="zh">{{ $t("入库验货、称重、拍照") }}<br>{{ $t("不合格直接退回") }}</span><span class="en">Inspected, weighed, photographed<br>Rejected if it fails</span></p>
      </div>
      <div class="flow__arrow">→</div>
      <div class="flow__node flow__node--us">
        <div class="flow__icon"><svg class="ico"><use href="#i-plane"/></svg></div>
        <em><span class="zh">{{ $t("国际段") }}</span><span class="en">International leg</span></em>
        <p><span class="zh">{{ $t("燕文 / 4PX 专线") }}<br>{{ $t("或集运合箱") }}</span><span class="en">Yanwen / 4PX lines<br>or consolidated</span></p>
      </div>
      <div class="flow__arrow">→</div>
      <div class="flow__node flow__node--you">
        <div class="flow__icon"><svg class="ico"><use href="#i-store"/></svg></div>
        <em><span class="zh">{{ $t("你的店") }}</span><span class="en">Your store</span></em>
        <p><span class="zh">{{ $t("价格你定") }}<br>{{ $t("品牌是你的") }}</span><span class="en">You set the price<br>The brand is yours</span></p>
      </div>
      <div class="flow__arrow">→</div>
      <div class="flow__node flow__node--you">
        <div class="flow__icon"><svg class="ico"><use href="#i-user"/></svg></div>
        <em><span class="zh">{{ $t("你的客户") }}</span><span class="en">Your customer</span></em>
        <p><span class="zh">{{ $t("下单、付款、收货") }}<br>{{ $t("数据留在你后台") }}</span><span class="en">Orders, pays, receives<br>Data stays with you</span></p>
      </div>
    </div>
    <div class="flow__legend">
      <i><span class="zh">{{ $t("紫色：我们替你办") }}</span><span class="en">Purple: we handle it</span></i>
      <i class="grey"><span class="zh">{{ $t("灰色：你只需要做这一步") }}</span><span class="en">Grey: all you do</span></i>
    </div>
  </div>
</section>

<!-- ============ 4 两档做法 ============ -->
<section class="sec" id="ways">
  <div class="wrap">
    <div class="sec__head">
      <span class="pill"><span class="zh">{{ $t("两档做法") }}</span><span class="en">Two ways to start</span></span>
      <h2 class="sec__title"><span class="zh">{{ $t("先轻后重：先代发跑通，再备货放大") }}</span><span class="en">Start light. Go heavy when it works.</span></h2>
      <p class="sec__sub"><span class="zh">{{ $t("同一个店，两种节奏。不用一上来就把钱压进去。") }}</span><span class="en">Same store, two speeds. You don't have to put money down on day one.</span></p>
    </div>

    <div class="duo">
      <div class="duo__card">
        <span class="duo__icon"><svg class="ico"><use href="#i-box"/></svg></span>
        <span class="duo__step"><span class="zh">{{ $t("第一档 · 起步用这个") }}</span><span class="en">STEP ONE · START HERE</span></span>
        <h3><span class="zh">{{ $t("一件代发") }} <small>{{ $t("轻") }}</small></span><span class="en">Dropship <small>light</small></span></h3>
        <p class="duo__lead">
          <span class="zh">{{ $t("客户在你的店下单，我们采购、验货、出国际单，一直送到他手上。你只需要把商品挂上去。") }}</span>
          <span class="en">Your customer orders. We buy, inspect and ship internationally — straight to their door. All you did was list the product.</span>
        </p>
        <ul class="duo__list">
          <li><span class="zh">{{ $t("零库存、零资金占用，卖不动就换品") }}</span><span class="en">Zero inventory, zero capital tied up</span></li>
          <li><span class="zh">{{ $t("单件成本高一点，但不用赌") }}</span><span class="en">Higher unit cost — but you're not betting on stock</span></li>
          <li><span class="zh">{{ $t("适合新店、新品、没试过的品类") }}</span><span class="en">Right for new stores and untested products</span></li>
        </ul>
        <p class="duo__cost"><span class="zh">{{ $t("适合：") }}<b>{{ $t("还没验证过的品") }}</b></span><span class="en">Best for: <b>products you haven't proven</b></span></p>
      </div>

      <div class="duo__mid">
        <span><span class="zh">{{ $t("跑通之后") }}</span><span class="en">once it sells</span></span>
        <b>→</b>
      </div>

      <div class="duo__card duo__card--accent">
        <span class="duo__icon"><svg class="ico"><use href="#i-layers"/></svg></span>
        <span class="duo__step"><span class="zh">{{ $t("第二档 · 放量用这个") }}</span><span class="en">STEP TWO · SCALE HERE</span></span>
        <h3><span class="zh">{{ $t("备货到本地") }} <small>{{ $t("重") }}</small></span><span class="en">Bulk to local <small>heavy</small></span></h3>
        <p class="duo__lead">
          <span class="zh">{{ $t("卖得动的品批量采购，走集运合箱或海外仓，单件成本和到货时间都压下来。") }}</span>
          <span class="en">Once a product sells, buy in bulk — consolidated shipping or a local warehouse cuts both unit cost and delivery time.</span>
        </p>
        <ul class="duo__list">
          <li><span class="zh">{{ $t("单件成本更低，利润更厚") }}</span><span class="en">Lower unit cost, better margin</span></li>
          <li><span class="zh">{{ $t("到货更快，客户体验和复购更好") }}</span><span class="en">Faster delivery, more repeat orders</span></li>
          <li><span class="zh">{{ $t("需要一点备货资金和仓位") }}</span><span class="en">Needs some capital and storage</span></li>
        </ul>
        <p class="duo__cost"><span class="zh">{{ $t("适合：") }}<b>{{ $t("已经卖稳的爆款") }}</b></span><span class="en">Best for: <b>proven best-sellers</b></span></p>
      </div>
    </div>
  </div>
</section>

<!-- ============ 5 AI 员工 ============ -->
<section class="sec sec--gray" id="ai">
  <div class="wrap">
    <div class="hl">
      <div class="hl__visual">
        <img src="/website/img/Marketing-1.png" :alt="$t('AI 员工')">
      </div>
      <div>
        <span class="pill"><span class="zh">{{ $t("不懂中文也能管店") }}</span><span class="en">No Mandarin required</span></span>
        <h3><span class="zh">{{ $t("18 位 AI 员工，替你处理日常") }}</span><span class="en">18 AI staff, handling the day-to-day</span></h3>
        <p>
          <span class="zh">{{ $t("商品、订单、增长、经营四组，按需订阅，不需要一次全开。") }}<b>{{ $t("你不用雇人，也不用学会中文后台") }}</b>{{ $t("——它们用你市场的语言干活。") }}</span>
          <span class="en">Four groups — product, orders, growth, operations. Subscribe to what you need. <b>No hires, and no Chinese dashboard to learn</b> — they work in your market's language.</span>
        </p>
        <div class="hl__grid">
          <div class="hl__cell">
            <div class="hl__cell-head"><svg class="ico"><use href="#i-sparkle"/></svg><strong><span class="zh">{{ $t("商品文案官") }}</span><span class="en">Listing writer</span></strong></div>
            <span><span class="zh">{{ $t("用目标市场的语言写标题和描述，不是机翻") }}</span><span class="en">Titles and descriptions written for your market</span></span>
          </div>
          <div class="hl__cell">
            <div class="hl__cell-head"><svg class="ico"><use href="#i-user"/></svg><strong><span class="zh">{{ $t("AI 客服") }}</span><span class="en">Support agent</span></strong></div>
            <span><span class="zh">{{ $t("7×24，用客户的语言回复，常见问题直接解决") }}</span><span class="en">24/7, in your customer's language</span></span>
          </div>
          <div class="hl__cell">
            <div class="hl__cell-head"><svg class="ico"><use href="#i-search"/></svg><strong><span class="zh">{{ $t("选品助手") }}</span><span class="en">Product scout</span></strong></div>
            <span><span class="zh">{{ $t("看哪些品在你的市场真的卖得动") }}</span><span class="en">Shows what actually sells where you are</span></span>
          </div>
          <div class="hl__cell">
            <div class="hl__cell-head"><svg class="ico"><use href="#i-box"/></svg><strong><span class="zh">{{ $t("经营日报") }}</span><span class="en">Daily brief</span></strong></div>
            <span><span class="zh">{{ $t("今天发生了什么，明天该做什么") }}</span><span class="en">What happened today, what to do tomorrow</span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============ 6 三步开始 ============ -->
<section class="sec" id="start">
  <div class="wrap">
    <div class="sec__head">
      <span class="pill"><span class="zh">{{ $t("怎么开始") }}</span><span class="en">Get started</span></span>
      <h2 class="sec__title"><span class="zh">{{ $t("三步，不用先付钱") }}</span><span class="en">Three steps, no money down</span></h2>
    </div>
    <div class="start">
      <div class="start__item">
        <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-browser"/></svg></span>
        <span class="start__no"><span class="zh">{{ $t("第一步") }}</span><span class="en">STEP 1</span></span>
        <h4><span class="zh">{{ $t("注册开店") }}</span><span class="en">Create your store</span></h4>
        <p><span class="zh">{{ $t("几分钟注册，不需要信用卡。店名和域名随时能改。") }}</span><span class="en">Sign up in minutes. No credit card.</span></p>
        <span class="start__time"><span class="zh">{{ $t("约 5 分钟") }}</span><span class="en">~5 min</span></span>
      </div>
      <div class="start__item">
        <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-search"/></svg></span>
        <span class="start__no"><span class="zh">{{ $t("第二步") }}</span><span class="en">STEP 2</span></span>
        <h4><span class="zh">{{ $t("挑商品") }}</span><span class="en">Pick products</span></h4>
        <p><span class="zh">{{ $t("从中国商品库挑，或者导入你自己的货源。看中就一键铺到店里。") }}</span><span class="en">Choose from the catalog, or import your own supply.</span></p>
        <span class="start__time"><span class="zh">{{ $t("当天能挑完") }}</span><span class="en">Same day</span></span>
      </div>
      <div class="start__item">
        <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-rocket"/></svg></span>
        <span class="start__no"><span class="zh">{{ $t("第三步") }}</span><span class="en">STEP 3</span></span>
        <h4><span class="zh">{{ $t("开卖") }}</span><span class="en">Start selling</span></h4>
        <p><span class="zh">{{ $t("客户下单，我们发货。物流他自己能查，售后有人接。") }}</span><span class="en">Your customer orders, we ship. They track it themselves.</span></p>
        <span class="start__time"><span class="zh">{{ $t("0 库存") }}</span><span class="en">Zero stock</span></span>
      </div>
    </div>

    <p style="text-align:center;margin-top:32px;font-size:14px;color:var(--muted)">
      <span class="zh">{{ $t("你在中国，想把货卖出去？") }}<router-link to="/for-china-sellers" style="color:var(--p)">{{ $t("看这一页 →") }}</router-link></span>
      <span class="en">Based in China and want to sell abroad? <router-link to="/for-china-sellers" style="color:var(--p)">Read this →</router-link></span>
    </p>
  </div>
</section>

<section class="sec sec--tight">
  <div class="wrap">
    <div class="pandy">
      <img class="pandy__m" src="/website/img/tao-box.png" alt="">
      <div>
        <p class="pandy__t">{{ $t("第一公里是最容易低估的一段") }}</p>
        <p class="pandy__b">{{ $t("工厂到仓、仓到口岸、口岸到干线——") }}<b>{{ $t("这三段任何一段卡住，后面全乱") }}</b>{{ $t("。先把这一段跑顺，再谈增长。") }}</p>
      </div>
    </div>
  </div>
</section>

<!-- ============ 7 结论条 ============ -->
<section class="band">
  <div class="wrap">
    <h2>
      <span class="zh">{{ $t("你挑货、定价、卖货，货从中国直接到客户手上。") }}</span>
      <span class="en">You pick, price and sell. The goods go from China straight to your customer.</span>
    </h2>
    <p>
      <span class="zh">{{ $t("不需要仓库，不需要员工，也不需要会说中文。") }}</span>
      <span class="en">No warehouse. No staff. No Mandarin.</span>
    </p>
  </div>
</section>

</main>
</template>

<script>
export default {
  name: 'WebsiteForGlobalSellers',
}
</script>
